export default {
	SS_Menu: [
		{
			PreviewMenuId: 0,
			DisplayName: "Event Info",
			DisplayOrder: 1,
			StepStatus: "",
			routeTo: "/eventsetup",
			routeName: "EventSetup",
			IsPublished: true,
		},
		{
			PreviewMenuId: 0,
			DisplayName: "Banner & Logo",
			DisplayOrder: 2,
			StepStatus: "",
			routeTo: "/evenbranding",
			routeName: "EvenBranding",
			IsPublished: true,
		},
		{
			PreviewMenuId: 0,
			DisplayName: "Registration",
			DisplayOrder: 3,
			StepStatus: "",
			routeTo: "/admin-event/{{EventId}}",
			routeName: "AdminEvent",
			IsPublished: true,
		},
		{
			PreviewMenuId: 1001,
			DisplayName: "Upload Attendees (optional)",
			DisplayOrder: 4,
			StepStatus: "",
			routeTo: "/admin-attendee",
			routeName: "AdminAttendeeList",
			IsPublished: true,
		},
		
		{
			PreviewMenuId: 1005,
			DisplayName: "Setup Speakers",
			DisplayOrder: 5,
			StepStatus: "",
			routeTo: "/admin-speakers",
			routeName: "AdminSpeakerList",
			IsPublished: true,
		},
		{
			PreviewMenuId: 0,
			DisplayName: "Setup Sessions",
			DisplayOrder: 6,
			StepStatus: "",
			routeTo: "/admin-sessions",
			routeName: "AdminSessions",
			IsPublished: true,
		},
		{
			PreviewMenuId: 1004,
			DisplayName: "Setup Roundtable",
			DisplayOrder: 7,
			StepStatus: "",
			routeTo: "/admin-roundtable",
			routeName: "AdminRoundtableList",
			IsPublished: false,
		},
		{
			PreviewMenuId: 1003,
			DisplayName: "Setup Expo",
			DisplayOrder: 8,
			StepStatus: "",
			routeTo: "/admin-exhibitorshall",
			routeName: "AdminExbitorshall",
			IsPublished: false,
		},
		{
			PreviewMenuId: 1006,
			DisplayName: "Setup Sponsors",
			DisplayOrder: 9,
			StepStatus: "",
			routeTo: "/admin-sponsors",
			routeName: "AdminSponsorList",
			IsPublished: false,
		},
		{
			PreviewMenuId: 1030,
			DisplayName: "Live Stage",
			DisplayOrder: 10,
			StepStatus: "",
			routeTo: "/admin-stageview",
			routeName: "AdminStageView",
			IsPublished: true,
		},
	]
}